/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BackendRoutes } from '../../constants'
import { Observable } from 'rxjs'
import { AppConfig } from './config.interface'
import { environment } from '../../../environments/environment'
import { WINDOW } from '../utils'

@Injectable({
  providedIn: 'root',
})
export class ConfigLoaderService {
  private _httpClient = inject(HttpClient)
  private _window = inject<Window>(WINDOW)

  get localisationBaseUrl(): string {
    return this._window.location.hostname.includes('.cn') ? environment.urls.localisationCN : environment.urls.localisation
  }

  public getConfig(locale: string, country: string): Observable<AppConfig> {
    if (locale.length === 2) {
      locale = locale.toLowerCase() + '_' + country.toUpperCase()
    }
    let updatedLocale: string
    if (locale.includes('-')) {
      const [l1, l2] = locale.split('-')
      updatedLocale = `${l1.toLowerCase()}_${l2.toUpperCase()}`
    } else {
      const [l1, l2] = locale.split('_')
      updatedLocale = `${l1.toLowerCase()}_${l2.toUpperCase()}`
    }
    const configBasePath = BackendRoutes.CONFIG_BASE.replace(':country', country.toLowerCase())
      .replace(':locale', updatedLocale)
      .replace(':stage', environment.production ? 'p' : 'pp')
      .replace(':version', environment.production ? 'RELEASE' : 'LATEST')

    const configBaseUrl = `${this.localisationBaseUrl}${configBasePath}`

    return this._httpClient.get<AppConfig>(configBaseUrl)
  }
}
